// Hooks de domínio da auth — wrappers finos pra páginas usarem sem importar mutations diretas.
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '@/app/store/hooks';
import { ROUTES } from '@/app/router/paths';
import { sessionEnded } from './slice';
import { clearSession } from '@/lib/auth/token-storage';
import { stopTokenRefreshScheduler } from '@/lib/auth/refresh-scheduler';
import { useLogoutMutation } from './api';

export function useLogout(): { logout: () => Promise<void>; isLoading: boolean } {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [trigger, { isLoading }] = useLogoutMutation();

  const logout = useCallback(async () => {
    try {
      await trigger().unwrap();
    } catch {
      // mesmo se o back falhar, devolve sessão local — desktop é frágil.
    } finally {
      stopTokenRefreshScheduler();
      clearSession();
      dispatch(sessionEnded());
      navigate(ROUTES.login, { replace: true });
    }
  }, [trigger, dispatch, navigate]);

  return { logout, isLoading };
}
